import r from "gatsby-background-image";
import e from "react";
function l() {
  return (l = Object.assign || function (r) {
    for (var e = 1; e < arguments.length; e++) {
      var l = arguments[e];
      for (var t in l) Object.prototype.hasOwnProperty.call(l, t) && (r[t] = l[t]);
    }
    return r;
  }).apply(this, arguments);
}
const t = r => "[object String]" === Object.prototype.toString.call(r),
  n = r => "fixed" === r.layout ? "fixed" : "fluid",
  i = r => {
    let e;
    for (e = 0; e < r.length; e++) if (!t(r[e])) return r[e];
    return null;
  },
  u = r => r.width / r.height,
  a = r => {
    var e, l, t, n;
    return r.placeholder ? null != (e = r.placeholder) && null != (l = e.fallback) && l.includes("base64") ? {
      base64: null == (t = r.placeholder) ? void 0 : t.fallback
    } : {
      tracedSVG: null == (n = r.placeholder) ? void 0 : n.fallback
    } : {};
  },
  c = r => {
    if (r.srcSet) {
      var e;
      const l = [...r.srcSet.matchAll(/(?:([^"'\s,]+)\s*(?:\s+\d+[wx])(?:,\s*)?)/gm)],
        t = r.sizes.replace("px", ""),
        n = l.filter(r => (null == r ? void 0 : r[0].includes("100w")) || (null == r ? void 0 : r[0].includes("1x")) || (null == r ? void 0 : r[0].includes(`${t}w`)));
      return (null == n || null == (e = n[0]) ? void 0 : e[1]) || "";
    }
    return "";
  },
  o = r => {
    var e, l, t;
    return null != (e = r.images) && e.sources && Array.isArray(null == (l = r.images) ? void 0 : l.sources) ? null == (t = r.images) ? void 0 : t.sources.reduce((r, e) => {
      var l;
      const t = (null == e || null == (l = e.type) ? void 0 : l.split("/")[1]) || "",
        n = (null == t ? void 0 : t.charAt(0).toUpperCase()) + t.slice(1),
        i = `srcSet${n}`,
        u = `src${n}`;
      return n && (!(i in r) && null != e && e.srcSet && (r[i] = e.srcSet), !(u in r) && null != e && e.srcSet && (r[u] = c(e))), r;
    }, {}) : {};
  },
  s = r => {
    if (r && r.layout) {
      const e = {},
        t = n(r),
        i = u(r),
        c = a(r),
        s = o(r);
      return e[t] = l({}, r.images.fallback, s, c, "fluid" === t ? {
        aspectRatio: i
      } : {}, "fixed" === t ? {
        width: r.width,
        height: r.height
      } : {}), e;
    }
    return null;
  };
function d(r) {
  if (r) {
    if (Array.isArray(r)) {
      const [e, u] = (r => {
        const e = i(r);
        if (e) {
          const i = n(e),
            u = r.map(r => {
              if (t(r)) return r;
              const e = s(r);
              return l({}, e && e[i], null != r && r.media ? {
                media: r.media
              } : {});
            });
          return [i, u];
        }
        return [];
      })(r);
      return e ? {
        [e]: u
      } : null;
    }
    return s(r);
  }
  return null;
}
const f = t => {
  const {
      image: n,
      children: i
    } = t,
    u = function (r, e) {
      if (null == r) return {};
      var l,
        t,
        n = {},
        i = Object.keys(r);
      for (t = 0; t < i.length; t++) e.indexOf(l = i[t]) >= 0 || (n[l] = r[l]);
      return n;
    }(t, ["image", "children"]),
    a = n && d(n);
  return a ? e.createElement(r, l({}, a, u), i) : e.createElement("div", null, i);
};
export { f as BgImage, s as convertSingleBgImage, d as convertToBgImage, o as getAllExtraSrcSets, u as getAspectRatio, n as getBgImageType, a as getPlaceholder, i as getSingleImage, c as getSrc, t as isString };